// For IE11 support
import { enableES5 } from 'immer';
enableES5();

import produce from 'immer';
import { TICKET_MGMT_TYPES } from '../../constants/actionTypes/ticketMgmtActionTypes';

export const INITIAL_STATE = {
    loaded: false,
    entities: [],
    options: {
        optionsLoaded: false,
        workflowTypes: [],
        workgroups: [],
        permissions: []
    }
};

export default produce((draft = INITIAL_STATE, action = {}) => {
    const { type, workflowTypes, workgroups, permissions, workflowsByCategory } = action;
    switch (type) {
        case TICKET_MGMT_TYPES.GET_WORKFLOWS_BY_CATEGORY:
            draft.loaded = true;
            draft.entities = workflowsByCategory;
            break;

        case TICKET_MGMT_TYPES.GET_WORKFLOW_TYPES:
            draft.options.optionsLoaded = true;
            draft.options = { ... draft.options, workflowTypes };
            break;

        case TICKET_MGMT_TYPES.GET_WORKGROUPS:
            draft.options = { ... draft.options, workgroups };
            break;

        case TICKET_MGMT_TYPES.GET_PERMISSIONS:
            draft.options = { ... draft.options, permissions };
            break;

        case TICKET_MGMT_TYPES.SELECT_CATEGORY:
            draft.loaded = false;
            draft.entities = [];
            break;

        default:
            return draft;
    }
});